import { Link } from "@tanstack/react-router";
import type { ComponentProps, ReactNode } from "react";
import { useLocale } from "@/hooks/useLocale";
import { localePath } from "@/lib/i18n";

type Props = Omit<ComponentProps<"a">, "href"> & {
  to: string;
  children: ReactNode;
  activeClassName?: string;
  /** Optional query params forwarded to the target route. */
  search?: Record<string, string>;
};

/**
 * Internal link that keeps the visitor inside their current language.
 * Paths are written without the locale prefix (e.g. "/prices").
 */
export function LocaleLink({ to, children, ...rest }: Props) {
  const locale = useLocale();
  const href = localePath(locale, to);
  return (
    <Link to={href as never} {...(rest as Record<string, unknown>)}>
      {children}
    </Link>
  );
}
